<template>
  <div>
    <PageHeader title="จัดการข้อมูลอื่นๆ" />
    <b-container fluid="xl" class="pt-5">
      <div>
        <div class="card card-csq no-shadow">
          <b-tabs card>
            <b-tab title="ประเภทวิชา" active>
              <WannasornAdditionalCourseInfoManager
                type="SUBJECT"
                :items="subjectTypeList"
                :current-page="paginationState['SUBJECT'].current"
                :per-page="paginationState['SUBJECT'].size"
                :search-value="searchStates['SUBJECT']"
                @fetchData="fetchData()"
                @searchItem="
                  (val) => (
                    (searchStates['SUBJECT'] = val.q), (type = val.type)
                  )
                "
                @update:currentPage="
                  (val) => (paginationState['SUBJECT'].current = val)
                "
                @update:perPage="
                  (val) => (paginationState['SUBJECT'].size = val)
                "
                :isLoading="isLoading"
              />
            </b-tab>
            <b-tab title="ระดับชั้นเรียน">
              <WannasornAdditionalCourseInfoManager
                type="LEVEL"
                :items="academicLevelList"
                :current-page="paginationState['LEVEL'].current"
                :per-page="paginationState['LEVEL'].size"
                :search-value="searchStates['LEVEL']"
                @fetchData="fetchData()"
                @searchItem="
                  (val) => ((searchStates['LEVEL'] = val.q), (type = val.type))
                "
                @update:currentPage="
                  (val) => (paginationState['LEVEL'].current = val)
                "
                @update:perPage="(val) => (paginationState['LEVEL'].size = val)"
                :isLoading="isLoading"
              />
            </b-tab>
            <b-tab title="ภาคการศึกษา">
              <WannasornAdditionalCourseInfoManager
                type="TERM"
                :items="academicTermList"
                :current-page="paginationState['TERM'].current"
                :per-page="paginationState['TERM'].size"
                :search-value="searchStates['TERM']"
                @fetchData="fetchData()"
                @searchItem="
                  (val) => ((searchStates['TERM'] = val.q), (type = val.type))
                "
                @update:currentPage="
                  (val) => (paginationState['TERM'].current = val)
                "
                @update:perPage="(val) => (paginationState['TERM'].size = val)"
                :isLoading="isLoading"
              />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PageHeader from "./../../layouts/PageHeader";
import WannasornAdditionalCourseInfoManager from "./partials/WannasornAdditionalCourseInfoManager.vue";

export default {
  components: {
    PageHeader,
    WannasornAdditionalCourseInfoManager,
  },
  data() {
    return {
      type: "",
      isLoading: false,
      paginationState: {
        SUBJECT: { current: 1, size: 5 },
        LEVEL: { current: 1, size: 5 },
        TERM: { current: 1, size: 5 },
      },
      searchQuery: "",
      searchStates: {
        SUBJECT: "",
        LEVEL: "",
        TERM: "",
      },
    };
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    ...mapGetters("CourseManagement", [
      "subjectTypeList",
      "academicLevelList",
      "academicTermList",
    ]),
  },
  methods: {
    ...mapActions("CourseManagement", [
      "getSubjectTypeList",
      "getAcademicLevelList",
      "getAcademicTermList",
    ]),
    async fetchData() {
      this.isLoading = true;
      await this.getSubjectTypeList();
      await this.getAcademicLevelList();
      await this.getAcademicTermList();
      this.isLoading = false;
    },
    async filterDate() {
      const currentSearch = this.searchStates[this.type];
      let params = {
        q: currentSearch,
      };

      if (this.type === "SUBJECT") {
        await this.getSubjectTypeList(params);
      } else if (this.type === "LEVEL") {
        await this.getAcademicLevelList(params);
      } else if (this.type === "TERM") {
        await this.getAcademicTermList(params);
      }
    },
  },
  watch: {
    searchStates: {
      deep: true,
      handler() {
        this.paginationState[this.type].current = 1;
        this.filterDate();
      },
    },
  },
};
</script>
